module.exports = __webpack_public_path__ + "img/newsImg-1.b1289a32.png";